// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/mask.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResetPassword_container__zf-tg {
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding-top: 5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    z-index: 1;
  }
  
  .ResetPassword_container__zf-tg::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: -1;
  }
  
  .ResetPassword_formCard__u3Zx2 {
    background: rgba(31, 31, 31, 0.8);
    padding: 2rem;
    border-radius: 12px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .ResetPassword_formCard__u3Zx2 h2 {
    color: white;
    text-align: center;
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }
  
  .ResetPassword_instructions__EDF\\+- {
    color: white;
    text-align: center;
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
    opacity: 0.8;
  }
  
  .ResetPassword_form__7GAjZ {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .ResetPassword_inputGroup__B7Dkv {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .ResetPassword_inputGroup__B7Dkv input {
    padding: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.05) !important;
    color: white;
    width: 93%;
  }
  
  .ResetPassword_inputGroup__B7Dkv input::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  
  .ResetPassword_errorInput__GrlTk {
    border-color: #ff4444 !important;
  }
  
  .ResetPassword_errorText__GwGXi {
    color: #ff4444;
    font-size: 0.75rem;
  }
  
  .ResetPassword_submitButton__uP0tr {
    background: #ff0000;
    color: white;
    padding: 0.75rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.2s;
  }
  
  .ResetPassword_signInLink__XY5Y9 {
    color: red;
    cursor: pointer;
    text-decoration: underline;
  }
  
  .ResetPassword_submitButton__uP0tr:hover {
    background: #cc0000;
  }
  
  .ResetPassword_submitButton__uP0tr.ResetPassword_loading__YOQHr {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  .ResetPassword_loadingWrapper__T1hkR {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  
  .ResetPassword_spinner__qJPco {
    animation: ResetPassword_spin__XLQG9 1s linear infinite;
  }
  
  @keyframes ResetPassword_spin__XLQG9 {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  .ResetPassword_loginLink__jWETs {
    text-align: center;
    color: white;
    font-size: 0.875rem;
    margin-top: 1rem;
  }
  
  @media (max-width: 480px) {
    .ResetPassword_formCard__u3Zx2 {
      padding: 1.5rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/auth/resetpassword/ResetPassword.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yDAAwD;IACxD,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,wCAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;IAClB,gDAAgD;IAChD,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,uDAAkC;EACpC;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE;MACE,eAAe;IACjB;EACF","sourcesContent":[".container {\n    position: relative;\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-image: url('../../../public/images/mask.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    padding-top: 5rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    z-index: 1;\n  }\n  \n  .container::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: -1;\n  }\n  \n  .formCard {\n    background: rgba(31, 31, 31, 0.8);\n    padding: 2rem;\n    border-radius: 12px;\n    width: 100%;\n    max-width: 400px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .formCard h2 {\n    color: white;\n    text-align: center;\n    margin-bottom: 1rem;\n    font-size: 1.5rem;\n  }\n  \n  .instructions {\n    color: white;\n    text-align: center;\n    margin-bottom: 1.5rem;\n    font-size: 0.9rem;\n    opacity: 0.8;\n  }\n  \n  .form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .inputGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .inputGroup input {\n    padding: 0.75rem;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 6px;\n    background: rgba(255, 255, 255, 0.05) !important;\n    color: white;\n    width: 93%;\n  }\n  \n  .inputGroup input::placeholder {\n    color: rgba(255, 255, 255, 0.5);\n  }\n  \n  .errorInput {\n    border-color: #ff4444 !important;\n  }\n  \n  .errorText {\n    color: #ff4444;\n    font-size: 0.75rem;\n  }\n  \n  .submitButton {\n    background: #ff0000;\n    color: white;\n    padding: 0.75rem;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: background-color 0.2s;\n  }\n  \n  .signInLink {\n    color: red;\n    cursor: pointer;\n    text-decoration: underline;\n  }\n  \n  .submitButton:hover {\n    background: #cc0000;\n  }\n  \n  .submitButton.loading {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n  \n  .loadingWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n  }\n  \n  .spinner {\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .loginLink {\n    text-align: center;\n    color: white;\n    font-size: 0.875rem;\n    margin-top: 1rem;\n  }\n  \n  @media (max-width: 480px) {\n    .formCard {\n      padding: 1.5rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ResetPassword_container__zf-tg`,
	"formCard": `ResetPassword_formCard__u3Zx2`,
	"instructions": `ResetPassword_instructions__EDF+-`,
	"form": `ResetPassword_form__7GAjZ`,
	"inputGroup": `ResetPassword_inputGroup__B7Dkv`,
	"errorInput": `ResetPassword_errorInput__GrlTk`,
	"errorText": `ResetPassword_errorText__GwGXi`,
	"submitButton": `ResetPassword_submitButton__uP0tr`,
	"signInLink": `ResetPassword_signInLink__XY5Y9`,
	"loading": `ResetPassword_loading__YOQHr`,
	"loadingWrapper": `ResetPassword_loadingWrapper__T1hkR`,
	"spinner": `ResetPassword_spinner__qJPco`,
	"spin": `ResetPassword_spin__XLQG9`,
	"loginLink": `ResetPassword_loginLink__jWETs`
};
export default ___CSS_LOADER_EXPORT___;
